import Codec from "./codec"
import { AssignmentQuestionsWorkedOn } from "../domain/assignment_questions-worked-on"

export interface AssignmentQuestionsWorkedOnResponse {
  three_month: number | undefined
  one_month: number | undefined
  nine_month: number | undefined
  this_year: number | undefined
  this_month: number | undefined
  six_month: number | undefined
  eighteen_month: number | undefined
  twelve_month: number | undefined
}

export class AssignmentQuestionsWorkedOnCodec extends Codec {
  constructor() {
    super()
  }

  encode(
    value: AssignmentQuestionsWorkedOn,
  ): AssignmentQuestionsWorkedOnResponse {
    return {
      three_month: value.threeMonth,
      one_month: value.oneMonth,
      nine_month: value.nineMonth,
      this_year: value.thisYear,
      this_month: value.thisMonth,
      six_month: value.sixMonth,
      eighteen_month: value.eighteenMonth,
      twelve_month: value.twelveMonth,
    }
  }

  decode(
    value: AssignmentQuestionsWorkedOnResponse | null,
  ): AssignmentQuestionsWorkedOn | null {
    if (value) {
      return new AssignmentQuestionsWorkedOn(
        value.three_month,
        value.one_month,
        value.nine_month,
        value.this_year,
        value.this_month,
        value.six_month,
        value.eighteen_month,
        value.twelve_month,
      )
    }
    return null
  }
}
